import type {
  CompStructure,
  LayoutSize,
  SerializedCompStructure,
} from '@wix/document-services-types';
import { Sizes } from '@wix/editor-package-document-services';
import { DEFAULT_RESPONSIVE_SECTION_HEIGHT } from '../constants';

const MIN_SIZE = Sizes.createNoneMinUnitSize() as LayoutSize;
const MAX_SIZE = Sizes.createNoneMaxUnitSize() as LayoutSize;

const createSectionLayouts = (): NonNullable<CompStructure['layouts']> => ({
  componentLayout: {
    type: 'ComponentLayout',
    height: {
      type: 'auto',
    },
    maxHeight: MAX_SIZE,
    minHeight: MIN_SIZE,
    maxWidth: MAX_SIZE,
    minWidth: MIN_SIZE,
  },
  itemLayout: {
    id: '',
    type: 'GridItemLayout',
    gridArea: {
      rowStart: 1,
      columnStart: 1,
      rowEnd: 2,
      columnEnd: 2,
    },
    alignSelf: 'stretch',
    justifySelf: 'stretch',
  },
  containerLayout: {
    type: 'GridContainerLayout',
    rows: [
      {
        max: { type: 'auto' },
        min: { type: 'spx', value: DEFAULT_RESPONSIVE_SECTION_HEIGHT },
        type: 'MinMaxSize',
      },
    ],
    columns: [
      {
        max: {
          type: 'fr',
          value: 1,
        },
        min: MIN_SIZE,
        type: 'MinMaxSize',
      },
    ],
  },
  type: 'SingleLayoutData',
});

const sectionStyle = {
  type: 'ComponentStyle',
  style: {
    properties: {
      'alpha-bg': '0',
      bg: 'color_11',
    },
    propertiesSource: {
      'alpha-bg': 'value',
      bg: 'theme',
    },
    groups: {},
  },
  componentClassName: 'responsive.components.Section',
  pageId: '',
  compId: '',
  styleType: 'custom',
  skin: 'wysiwyg.viewer.skins.area.RectangleArea',
} satisfies CompStructure['style'];

export const createResponsiveSection = (): SerializedCompStructure => ({
  type: 'Container',
  components: [],
  componentType: 'responsive.components.Section',
  scopedLayouts: {
    // TODO: Enable this once settings widget's dimensions in mobile works
    // 'universal-editor-app-mobile-breakpoint': createSectionLayouts(
    //   sectionHeights.mobile,
    // ),
  },
  layouts: createSectionLayouts(),
  scopedStyles: {},
  style: sectionStyle,
  activeModes: {},
});
